var _path, _circle, _mask, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCustody(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3338 18.2222C35.4065 18.2222 32.2227 21.5545 32.2227 25.6649C32.2227 28.7134 33.9759 31.3301 36.4828 32.4807V41.0903C36.4828 41.5066 36.6487 41.904 36.9412 42.1863L38.4828 43.6749C38.9541 44.1299 39.6873 44.104 40.1291 43.6177L42.8551 40.6164C43.0845 40.3941 43.1521 40.0424 43.0227 39.7442L42.1819 37.8059V37.7585L43.3245 36.2767C43.6682 35.8306 43.6852 35.1993 43.3671 34.7329L42.1819 32.9972V32.4817C44.6902 31.3317 46.4449 28.7144 46.4449 25.6649C46.4449 21.5545 43.261 18.2222 39.3338 18.2222ZM39.3338 21.1993C40.381 21.1993 41.2301 22.0879 41.2301 23.184C41.2301 24.2801 40.381 25.1687 39.3338 25.1687C38.2865 25.1687 37.4375 24.2801 37.4375 23.184C37.4375 22.0879 38.2865 21.1993 39.3338 21.1993Z",
    fill: "#03F5AE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.7776,
    cy: 14.8889,
    r: 7.88889,
    stroke: "white",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_5037_18488",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 33.9991C34 33.742 33.9021 33.4939 33.7198 33.3126C30.4635 30.0761 25.4285 28 19.7778 28C9.95938 28 2 34.268 2 42C2 42.3953 2.02081 42.7868 2.06162 43.1739C2.11229 43.6546 2.53141 44 3.01477 44H33C33.5523 44 34 43.5523 34 43V33.9991Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7198 33.3126L35.1297 31.8941L33.7198 33.3126ZM35.1297 31.8941C31.459 28.2457 25.8981 26 19.7778 26V30C24.9589 30 29.468 31.9065 32.3099 34.7311L35.1297 31.8941ZM19.7778 26C9.32638 26 0 32.7446 0 42H4C4 35.7914 10.5924 30 19.7778 30V26ZM0 42C0 42.4656 0.0245143 42.9271 0.0726397 43.3836L4.05059 42.9642C4.01711 42.6466 4 42.325 4 42H0ZM3.01477 46H33V42H3.01477V46ZM36 43V33.9991H32V43H36ZM33 46C34.6569 46 36 44.6568 36 43H32C32 42.4477 32.4477 42 33 42V46ZM0.0726397 43.3836C0.240344 44.9744 1.60359 46 3.01477 46V42C3.45924 42 3.98424 42.3348 4.05059 42.9642L0.0726397 43.3836ZM32.3099 34.7311C32.0946 34.5172 32 34.2459 32 33.9991H36C36 33.2382 35.7096 32.4705 35.1297 31.8941L32.3099 34.7311Z",
    fill: "white",
    mask: "url(#path-3-inside-1_5037_18488)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCustody);
export default __webpack_public_path__ + "static/media/ic_custody.0efbd2d924215c9374e23431882afc40.svg";
export { ForwardRef as ReactComponent };